module.exports = __webpack_public_path__ + "static/media/lauch-video-QRcode.549db297.png";